/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { CircularProgressbar } from 'react-circular-progressbar'

import UiSelect from '../../components/UI/UISelect'
import UIButton from '../../components/UI/UIButton'
import UITextInput from '../../components/UI/UITextInput'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UIDocumentPicker from '../../components/UI/UIDocumentPicker'
import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'
import { fileUpload } from '../../api/apiService'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import {
  UploadResponse,
  trainingRecordCategories,
  trainingRecordCategoriesResponse,
  trainingRecordCategoriesResponseObj,
  trainingRecords,
  trainingResponse,
} from '../../utils/types'
import {
  createProfileTrainingRecord,
  getProfileTrainingRecord,
  getTrainingRecordCategories,
  updateProfileTrainingRecord,
} from '../../api/admin/myscrApis'
import {
  calculateNonNullPercentage,
  getTrainingScoreFields,
  aggregateTrainingScore,
} from '../../utils/utils'
import Modal from '../../components/UI/UIModal'
import { Icon } from '../../components/Icon'

export interface trainingRecordsData {
  certificateNumber?: string
  date?: string
  reviewDate?: string
  verifiedBy?: string
  verifiedByName?:string
  verificationDate?: string
  riskAssessmentStatus?: string
  duration?: string
  certificate?: string
  id?: string
  userId?: string
  trainingRecordCategoryId?: string
  createdAt?: string
  schoolId?: string
  title?: string
  updatedAt?: string
  referenceUrl?: string
  riskDocument?: string
}

export interface createRecordFormDataInterface {
  title?: string
  certificateNumber?: string
  date?: string
  reviewDate?: string
  verifiedBy?: string
  verificationDate?: string
  riskAssessmentStatus?: string
  duration?: string
  certificate?: string
  trainingRecordCategoryId?: string
  riskDocument?: string
  riskDocumentUrl?: string
}

export interface updateRecordFormDataInterface {
  title?: string
  certificateNumber?: string
  date?: string
  reviewDate?: string
  verifiedBy?: string
  verificationDate?: string
  riskAssessmentStatus?: string
  duration?: string
  certificate?: string
  trainingRecordCategoryId?: string
  id?: string
  userId?: string
  schoolId?: string
  createdAt?: string
  updatedAt?: string
  riskDocument?: string
}

type AnyObject = { [key: string]: any }
type AnyArray = any[]

// function convertNullsToUndefined(
//   obj: AnyObject | AnyArray
// ): AnyObject | AnyArray | undefined {
//   if (Array.isArray(obj)) {
//     return obj.map(convertNullsToUndefined)
//   } else if (obj !== null && typeof obj === 'object') {
//     return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
//       acc[key] = convertNullsToUndefined(obj[key])
//       return acc
//     }, {})
//   } else {
//     return obj === null ? undefined : obj
//   }
// }
function convertNullsToUndefined(
  obj: AnyObject | AnyArray,
  columnsToRemove?: string[]
): AnyObject | AnyArray | undefined {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertNullsToUndefined(item, columnsToRemove))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
      if (!columnsToRemove?.includes(key)) {
        // Check if the key is not in the columns to remove
        acc[key] = convertNullsToUndefined(obj[key], columnsToRemove)
      }
      return acc
    }, {})
  } else {
    return obj === null ? undefined : obj
  }
}

const TrainingRecord = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const [alertActive, setAlertActive] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const [trainingRecordsData, setTrainingRecordsData] =
    useState<trainingRecordsData[]>()
  const [createRecordFormData, setCreateRecordFormData] = useState<
    createRecordFormDataInterface[]
  >([])
  const [updateRecordFormData, setUpdateRecordFormData] = useState<
    updateRecordFormDataInterface[]
  >([])

  const fetchTrainingRecordCategories =
    async (): Promise<trainingRecordCategoriesResponseObj> => {
      const response =
        (await getTrainingRecordCategories()) as trainingRecordCategoriesResponse
      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const fetchTrainingRecord = async (): Promise<trainingRecords[]> => {
    const response = (await getProfileTrainingRecord()) as trainingResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const {
    data: trainingRecords,
    isLoading: isLoadingRecords,
    isError: isErrorRecords,
    refetch: refetchRecords,
  } = useQuery('userTraining', fetchTrainingRecord,
    {
      refetchOnWindowFocus: false, // Disable refetch on window focus
      refetchOnReconnect: false,  // Disable refetch on network reconnect
    }
  )
  const {
    data: trainingCategories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
    refetch: refetchCategories,
  } = useQuery('trainingRecordCategories', fetchTrainingRecordCategories,
    {
      refetchOnWindowFocus: false, // Disable refetch on window focus
      refetchOnReconnect: false,  // Disable refetch on network reconnect
    }
  )

  const convertToUndefined = (value: any) => (value ? value : undefined)

  useEffect(() => {
    if (trainingRecords !== undefined) {
      const mergedArray = trainingCategories?.data?.map((category) => {
        const matchingRecords =
          trainingRecords?.filter(
            (record) => record.trainingRecordCategoryId === category.id
          ) || []
        // If no matching records are found, include only the category title
        if (matchingRecords.length === 0) {
          return {
            title: category.title,
            trainingRecordCategoryId: category.id,
            referenceUrl: category?.referenceUrl,
          }
        } else {
          let obj = {}
          matchingRecords?.map((record: any) => {
            const updatedRecord: any = {}
            for (const key in record) {
              // eslint-disable-next-line no-prototype-builtins
              if (record.hasOwnProperty(key)) {
                updatedRecord[key] = convertToUndefined(record[key])
              }
            }
            obj = {
              ...record,
              title: category.title || undefined,
              referenceUrl: category?.referenceUrl,
            }
          })
          return obj
        }
      })
      if (mergedArray) setTrainingRecordsData(mergedArray)
    }
  }, [trainingRecords, trainingCategories])

  // const handleFieldChange = (
  //   index: number,
  //   fieldName: keyof trainingRecords,
  //   newValue: string
  // ) => {
  //   setUserData((prevDetails) => {
  //     const updatedDetails = [...(prevDetails ?? [])]
  //     // Find the employment detail object at the specified index
  //     const detailToUpdate = updatedDetails[index]
  //     // Update the specified field with the new value
  //     detailToUpdate[fieldName] = newValue
  //     return updatedDetails
  //   })
  // }

  const handleChange = (
    fieldName: string,
    value: string | boolean,
    item: trainingRecordsData
  ) => {
    setAlertActive(true)
    if (Object.keys(item)?.length > 3) {
      setTrainingRecordsData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.trainingRecordCategoryId === item.trainingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            if (index === existingItemIndex) {
              return {
                ...record,
                [fieldName]: value ? value : undefined,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
      })
      setUpdateRecordFormData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.trainingRecordCategoryId === item.trainingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            const { title, ...rest } = record
            if (index === existingItemIndex) {
              return {
                ...rest,
                [fieldName]: value ? value : undefined,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
      })
    } else {
      if (fieldName == 'certificate' || undefined) {
        setTrainingRecordsData((prev) => {
          if (!prev) {
            // If previous state is undefined, return a new array with the updated item
            return [
              {
                ...item,
                [fieldName]: value ? value : undefined,
              },
            ]
          }
          // Check if the item exists in the previous state
          const existingItemIndex = prev.findIndex(
            (record) =>
              record.trainingRecordCategoryId === item.trainingRecordCategoryId
          )
          if (existingItemIndex !== -1) {
            // If the item exists, update the specified field name with the provided value
            return prev.map((record, index) => {
              if (index === existingItemIndex) {
                return {
                  ...record,
                  [fieldName]: value ? value : undefined,
                }
              }
              return record
            })
          } else {
            // If the item doesn't exist, add it and update the specified field name with the provided value
            return [
              ...prev,
              {
                ...item,
                [fieldName]: value ? value : undefined,
              },
            ]
          }
        })
      }
      setCreateRecordFormData((prev) => {
        const matchingRecords =
          prev?.filter(
            (record) =>
              record.trainingRecordCategoryId === item.trainingRecordCategoryId
          ) || []
        if (matchingRecords.length === 0) {
          const newItem = {
            ...item,
            [fieldName]: value,
          }
          return [...prev, newItem]
        } else {
          const updatedRecords =
            prev?.map((record) => {
              if (
                record.trainingRecordCategoryId ===
                item.trainingRecordCategoryId
              ) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value ? value : undefined,
                }
              }
              return record
            }) || []

          return updatedRecords
        }
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: trainingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('certificate', response?.url, item)
      } catch (error) {
        handleChange(
          'certificate',
          item?.certificate ? item?.certificate : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    event.target.value = ''
  }
  const handleRiskFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: trainingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('riskDocument', response?.url, item)
      } catch (error) {
        handleChange(
          'riskDocument',
          item?.riskDocument ? item?.riskDocument : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }

  // const handleUpdateRecords = async (): Promise<void> => {
  //   console.log('create form data====>', createRecordFormData)
  //   console.log('update form data====>', updateRecordFormData)
  // }

  const handleUpdateRecords = async (): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      if (createRecordFormData?.length != 0) {
        const convertedValues = convertNullsToUndefined(createRecordFormData, [
          'title',
          'referenceUrl',
          'certificateUrl',
          'riskDocumentUrl',
          'verifiedByName'
        ])
        const response = (await createProfileTrainingRecord(
          convertedValues as any
        )) as {
          status?: string
          data: trainingRecords
        }
        if (response?.status == 'successful') {
          refetchCategories()
          refetchRecords()
          setCreateRecordFormData([])
          toast.success('Records Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      }
    } catch (error) {
      console.error('An error occurred:', error)
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
    try {
      setIsUpdateLoading(true)
      if (updateRecordFormData?.length != 0) {
        const convertedValues = convertNullsToUndefined(updateRecordFormData, [
          'title',
          'certificateUrl',
          'riskDocumentUrl',
          'verifiedByName'
        ])
        console.log('convertedValues ===> ', convertedValues)
        const response = (await updateProfileTrainingRecord(
          convertedValues as any
        )) as {
          status?: string
          data: trainingRecords
        }
        if (response?.status == 'successful') {
          setUpdateRecordFormData([])
          refetchCategories()
          refetchRecords()
          toast.success('Records Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      }
    } catch (error) {
      console.error('An error occurred:', error)
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target as Node) &&
      alertActive
    ) {
      setIsOpenAlert(true)
    } else if (isOpenAlert == false) {
      setAlertActive(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [alertActive])

  // Overall scorecard, shared with the candidate view via utils so the same
  // record scores identically here and on My SCR (Behaviour B).
  const scorecard = aggregateTrainingScore(
    trainingCategories?.data,
    trainingRecordsData
  )

  return (
    <div ref={divRef}>
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div
          style={{
            // height: 'calc(100vh - 100px)',
            overflow: 'auto',
            // scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          {trainingRecordsData?.map(
            (item: trainingRecordsData, index: number) => {
              return (
                <Accordion key={index} defaultActiveIndex={null}>
                  <AccordionItem
                    onClick={() => console.log('Accordion')}
                    title={item?.title ? item?.title : ''}
                    isActive={false}
                  >
                    <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                      <div className="flex w-full gap-4">
                        <div className="w-6/12  ">
                          <UITextInput
                            placeholder={'Certificate Number'}
                            label={'Certificate Number'}
                            iconName={''}
                            value={item ? item?.certificateNumber : ''}
                            onChange={(e) =>
                              handleChange(
                                'certificateNumber',
                                e.target.value,
                                item
                              )
                            }
                          />
                        </div>

                        <div className="w-6/12  ">
                          <UITextInput
                            readOnly
                            placeholder={'External Url'}
                            label={'External Url'}
                            iconName={''}
                            value={item?.referenceUrl ? item?.referenceUrl : ''}
                            onChange={(e) =>
                              handleChange('referenceUrl', e.target.value, item)
                            }
                          />
                        </div>
                      </div>

                      <UIDocumentPicker
                        id={item?.title ? item?.title : 'pickerInput'}
                        handleRemoveFile={() => {
                          handleChange('certificate', '', item)
                        }}
                        label={'Certificate'}
                        initialValue={
                          item?.certificate ? item?.certificate : ''
                        }
                        onChange={(e) =>
                          handleFileChange('certificate', e, item)
                        }
                        accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                        labelClassName="custom-label-class"
                      />
                      <div className="flex w-full gap-4">
                        <div className="w-6/12  ">
                          <UIDatePickerv
                            placeholderText={'Not Specified'}
                            title={'Date'}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              console.log(
                                'UIDatePickerve.target.value',
                                e.target.value
                              )
                              handleChange('date', e.target.value, item)
                            }}
                            value={item?.date ? item?.date.split('T')[0] : ''}
                          />
                        </div>
                        <div className="w-6/12">
                          <UIDatePickerv
                            placeholderText={'Not Specified'}
                            title={'Review Date'}
                            value={
                              item?.reviewDate
                                ? item?.reviewDate.split('T')[0]
                                : ''
                            }
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              handleChange('reviewDate', e.target.value, item)
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex w-full gap-4">
                        <div className="w-6/12  ">
                          <UITextInput
                            readOnly
                            placeholder={'Not specified'}
                            label={'Verified by'}
                            iconName={''}
                            value={item?.verifiedByName || ""}
                            // onChange={(e) =>
                            //   handleChange('verifiedBy', e.target.value, item)
                            // }
                          />
                        </div>
                        <div className="w-6/12">
                          <UIDatePickerv
                            readOnly
                            placeholderText={'Not Specified'}
                            title={'1rification Date'}
                            value={
                              item?.verificationDate
                                ? item?.verificationDate.split('T')[0]
                                : ''
                            }
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              handleChange(
                                'verificationDate',
                                e.target.value,
                                item
                              )
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className="flex w-full gap-4">
                        <div className="w-6/12  ">
                          <UiSelect
                            disabled={true}
                            options={[
                              { value: 'YES', label: 'YES' },
                              { value: 'NO', label: 'NO' },
                            ]}
                            title={'Risk Assessment Status'}
                            value={
                              item?.riskAssessmentStatus
                                ? item?.riskAssessmentStatus
                                : ''
                            }
                            onChange={(e: string) => {
                              handleChange('riskAssessmentStatus', e, item)
                            }}
                          />
                        </div>
                        <div className="w-6/12">
                          <UiSelect
                            disabled={true}
                            value={item?.duration}
                            options={[
                              { value: '12 Months', label: '12 Months' },
                              { value: '9 Months', label: '9 Months' },
                              { value: '6 Months', label: '6 Months' },
                              { value: '3 Months', label: '3 Months' },
                              { value: '0 Months', label: '0 Months' },
                            ]}
                            title={'Duration'}
                            onChange={(e: string) => {
                              handleChange('duration', e, item)
                            }}
                          />
                        </div>
                      </div> */}

                      <UIDocumentPicker
                        id={item?.title ? item?.title : 'pickerInput'}
                        handleRemoveFile={() => {
                          handleChange('riskDocument', '', item)
                        }}
                        label={'Risk Assessment Document'}
                        initialValue={
                          item?.riskDocument ? item?.riskDocument : ''
                        }
                        onChange={(e) =>
                          handleRiskFileChange('riskDocument', e, item)
                        }
                        accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                        labelClassName="custom-label-class"
                      />
                    </div>
                  </AccordionItem>
                </Accordion>
              )
            }
          )}
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm text-bluishGreen flex-1 font-semibold'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={scorecard.percentage}
                    text={`${scorecard.percentage}%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: scorecard.color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <div className="items-center justify-center flex">
                  <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                    {scorecard.percentage == 100
                      ? 'Well done you reached 100%'
                      : scorecard.percentage == 0
                        ? 'Make a start to improve your score'
                        : 'Great start! But there is still room for improvement'}
                  </p>
                </div>
                <Accordion defaultActiveIndex={0}>
                  <AccordionItem
                    onClick={() => console.log('Accordion')}
                    title={'Your score is broken down as follows:'}
                    isActive={false}
                    AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                    AccordiontitleStyle={
                      'text-xs font-semibold text-text4 leading-5 flex-1'
                    }
                    AccordionItemStyleContainer={{
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                      {trainingCategories?.data?.map((item, index) => (
                        <div key={index} className="">
                          <div className="">
                            <UIStaightlineProressBar
                              percentage={
                                calculateNonNullPercentage(
                                  getTrainingScoreFields(
                                    trainingRecordsData?.[index]
                                  )
                                ).percentage
                              }
                              label={item?.title}
                              stroke={
                                calculateNonNullPercentage(
                                  getTrainingScoreFields(
                                    trainingRecordsData?.[index]
                                  )
                                ).color
                              }
                              strokeWidth={1.5}
                            />
                          </div>
                        </div>
                      ))}
                      {/* <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={100}
                            label={'Safeguarding'}
                            stroke={'#01B38B'}
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={100}
                            label={'Prevent Duty'}
                            stroke={'#01B38B'}
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={100}
                            label={'EDI'}
                            stroke={'#01B38B'}
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={100}
                            label={'Wellbeing'}
                            stroke={'#01B38B'}
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={100}
                            label={'Health & Safety'}
                            stroke={'#01B38B'}
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={2}
                            label={'First Aid'}
                            stroke={'#FF6666'}
                            strokeWidth={1.5}
                          />
                        </div> */}
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="bg-gray3 w-full h-[1px] my-3"></div>
      <div className="w-[33%] mt-6">
        <UIButton
          loading={isUpdateLoading}
          onClick={handleUpdateRecords}
          label="Update"
        />
        <Modal
          customStyle={{ width: '480px', borderRadius: 16 }}
          isOpen={isOpenAlert}
          onClose={() => {
            setIsOpenAlert(false)
          }}
        >
          <div
            className={
              'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={() => {
                setIsOpenAlert(false)
              }}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconAlertTriangle'}
                stroke={'#FF6666'}
                strokeWidth={1}
                height={52}
                width={52}
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Save changes?
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Do you want to save changes before moving on?{' '}
              </p>
            </div>

            <button
              onClick={() => {
                handleUpdateRecords()
                setIsOpenAlert(false)
              }}
              className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
            >
              Save changes
            </button>
            <button
              onClick={() => {
                setIsOpenAlert(false)
              }}
              className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
            >
              {`Don't save`}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default TrainingRecord
